import { StageStore } from '@storage/components/stage/stage.store'

export class YardStageStore extends StageStore {
  draggable = true
  zoomable = true
}
